import { render, staticRenderFns } from "./ZipWithCitySuggestion.vue?vue&type=template&id=bfa2516a&"
import script from "./ZipWithCitySuggestion.vue?vue&type=script&lang=js&"
export * from "./ZipWithCitySuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports